import { writable } from "svelte/store";

export const favouriteList = writable([]);
